<template>
  <div>
    <!-- 采购处理 -->
    <el-dialog :title="$t('message.procurementProcess')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="1700px">
      <div class="table">
        <ol>
          <!-- 选择 -->
          <li class="flex05">
            <el-checkbox v-model="checked" @change="allChecked">
              {{ $t("message.allChecked") }}
            </el-checkbox>
          </li>
          <!-- 选择 -->
          <li class="flex05">NO</li>
          <!--  店铺信息-->
          <li class="flex15">
            {{ $t("message.storeInformation") }}
          </li>
          <!--照片-->
          <li>{{ $t("message.pic") }}</li>
          <!-- 商品属性 -->
          <li class="flex15">{{ $t("message.commodityAttribute") }}</li>
          <!--附加服务  -->
          <li class="flex15">
            {{ $t("message.additionalServices") }}
          </li>
          <!--业务报价  -->
          <li>{{ $t("message.businessOffer") }}</li>
          <!-- 财务付款后数量 -->
          <li>{{ $t("message.afterFinancialPaymentNum") }}</li>
          <!-- 财务付款后金额 -->
          <li>{{ $t("message.afterFinancialPaymentKin") }}</li>
          <!--商品状态  -->
          <li>{{ $t("message.itemStatus") }}</li>
          <!-- 问题图片 -->
          <li class="flex2">{{ $t("message.problemPic") }}</li>
          <!-- 问题产品数 -->
          <li>{{ $t("message.problemNunber") }}</li>
          <!-- 修改后数据 -->
          <li class="flex2">
            {{ $t("message.modifiedData") }}
          </li>
          <!-- 业务决策  -->
          <li class="flex2">
            {{ $t("message.businessDecisions") }}
          </li>
          <li class="flex2">
            采购处理
          </li>
          <!-- 采购处理备注  -->
          <li class="flex2">
            {{ $t("message.procurementProcessRemark") }}
          </li>
          <!-- 修改后数量  -->
          <li style="background-color: #fee0c3">
            {{ $t("message.editNumber") }}
          </li>
          <!-- 修改后单价.元  -->
          <li style="background-color: #fee0c3">
            {{ $t("message.editPrice") }}
          </li>
          <!-- 修改后运费.元  -->
          <li style="background-color: #fee0c3">
            {{ $t("message.editFreight") }}
          </li>
        </ol>
        <!-- 订单详情 -->
        <div class="detail" v-for="(item, index) in $parent.disposeList" :key="index">
          <!-- 交易号 -->
          <div class="head">
            {{ $t("message.transactionNumber") }}:
            <a :href="'https://trade.1688.com/order/new_step_order_detail.htm?orderId=' + item.purchase_no"
              v-if="item.purchase_no" target="_blank">
              {{ item.purchase_no }}</a>
            <span v-else> ———— </span>
            <span style="margin-left: 50px;"> 订单号: <router-link :to="'/orderPaymentDetail?order_sn=' + item.order_sn"
                target="_blank">{{ item.order_sn }}</router-link></span>
            <!-- 批量填充 -->
            <div class="bulkFilling">
              <el-button type="primary" @click="bulkFilling" size="small">{{ $t('message.bulkFilling') }}</el-button>
            </div>
          </div>
          <ul v-for="(items, indexs) in item.list" :key="indexs">
            <li class="flex05">
              <div>
                <el-checkbox v-model="items.checked" @change="choice"></el-checkbox>
              </div>
            </li>
            <li class="flex05">{{ items.sorting }}</li>
            <!-- 选择 -->
            <!--  店铺信息-->
            <li class="flex15">
              <div class="template">
                <p>{{ items.shop_name }}</p>
                <p>{{ items.from_platform }}</p>
                <p>{{ items.shop_id }}</p>
              </div>
            </li>
            <!--照片-->
            <li>
              <div class="img">
                <el-popover placement="right" width="300" trigger="hover">
                  <img :src="items.pic" alt="" style="width: 300px; height: 300px" />
                  <a :href="`https://detail.1688.com/offer/${items.goods_id}.html`" target="_blank" slot="reference">
                    <img :src="items.pic" alt="" />
                  </a>
                </el-popover>
              </div>
            </li>
            <!-- 商品属性 -->
            <li class="flex15">
              <div class="template">
                <p v-for="(skuItem, skuIndex) in items.detail_y" :key="skuIndex">
                  <span>{{ skuItem.key }}:</span>
                  <span>{{ skuItem.value }}</span>
                </p>
              </div>
            </li>
            <!--附加服务  -->
            <li class="flex15">
              <div class="scope">
                <el-popover placement="bottom-start" width="400" trigger="click">
                  <el-table :data="items.option" border size="mini" show-summary>
                    <el-table-column property="name" label="附加服务" align="center"></el-table-column>
                    <el-table-column property="num" label="数量" align="center"></el-table-column>
                    <el-table-column label="单价.元" align="center">
                      <template slot-scope="scope">
                        {{ scope.row.price }}
                      </template>
                    </el-table-column>
                    <el-table-column label="小计.元" align="center" property="total">
                    </el-table-column>
                  </el-table>
                  <div class="template" slot="reference">
                    <p v-for="opti in items.option" :key="opti.id">
                      {{ opti.tag }}{{ opti.name }}{{ opti.num }}
                    </p>
                  </div>
                </el-popover>
              </div>
            </li>
            <!--业务报价  -->
            <li>
              <div class="template">
                <!-- 单价 -->
                <!-- <p>
                  {{ $t("message.unitPrice") }}:{{ items.dicker_price }}
                </p> -->
                <!-- 价格 -->
                <p>{{ $t("message.price") }}:{{ items.offer_price_bak }}</p>
                <!-- 数量 -->
                <p>{{ $t("message.number") }}:{{ items.offer_num_bak }}</p>
                <!-- 运费-->
                <p>{{ $t("message.freight") }}:{{ items.offer_freight_bak }}</p>
              </div>
            </li>
            <!-- 财务付款后数量 -->
            <li>
              <div class="template">
                <!-- 可入库 -->
                <p>
                  {{ $t("message.canBePutIntoStorage") }}:{{ items.possible_num ? items.possible_num : "——" }}
                </p>
                <!-- 已到货 -->
                <p>
                  {{ $t("message.itHasArrived") }}:{{ items.storage_num ? items.storage_num : "——" }}
                </p>
                <!-- 已出货 -->
                <p>
                  {{ $t("message.hasBeenShipped") }}:{{ items.p_num ? items.p_num : "——" }}
                </p>
                <!-- 运费 -->
                <p>
                  {{ $t("message.freight") }}:{{ items.freight ? items.freight : "——" }}
                </p>
              </div>
            </li>
            <!-- 财务付款后金额 -->
            <li>
              <div class="template">
                <!-- 价格 -->
                <p>{{ $t("message.price") }}:{{ items.ccomfirm_price }}</p>
                <!-- 运费-->
                <p>{{ $t("message.freight") }}:{{ items.ccomfirm_freight }}</p>
              </div>
            </li>
            <!--商品状态  -->
            <li>{{ items.product_status_name }}</li>
            <!-- 问题图片 -->
            <li class="flex2">
              <div class="imgList">
                <div class="imgs" v-for="(imgs, imgIndex) in items.problem_goods_image" :key="imgIndex">
                  <img :src="imgs.isOss ? imgs.image + '?x-oss-process=image/resize,p_10' : imgs.image" class="avatar"
                    @click="handlePictureCardPreview(imgs.image)" />
                </div>
              </div>
            </li>
            <!-- 问题产品数 -->
            <li>
              {{ items.num }}
            </li>
            <!-- 修改后数据 -->
            <li class="flex2">
              <div class="template">
                <!-- 修改后数量 -->
                <p>{{ $t("message.editNumber") }}: {{ items.pre_num }}</p>
                <!-- 修改后单价 -->
                <p>{{ $t("message.editPrice") }}: {{ items.pre_price }}</p>
                <!-- 修改后运费 -->
                <p>{{ $t("message.editFreight") }}: {{ items.pre_freight }}</p>
                <el-popover placement="bottom-start" width="400" trigger="click" v-if="items.option_new">
                  <el-table :data="items.option_new" border size="mini" show-summary>
                    <el-table-column property="name" label="附加服务" align="center"></el-table-column>
                    <el-table-column property="num" label="数量" align="center"></el-table-column>
                    <el-table-column label="单价" align="center">
                      <template slot-scope="scope">
                        {{ scope.row.price }} {{ scope.row.unit }}
                      </template>
                    </el-table-column>
                    <el-table-column label="小计.元" align="center" property="total">
                    </el-table-column>
                  </el-table>
                  <div class="template" slot="reference">
                    <div v-for="(opti, optis) in items.option_new" :key="opti.id">
                      <p>{{ optis + 1 }}, {{ opti.name }} * {{ opti.num }}</p>
                    </div>
                  </div>
                </el-popover>
              </div>
            </li>
            <!-- 业务决策  -->
            <li class="flex2">
              <span v-if="items.y_deal">
                {{ items.y_deal }}
              </span>
              <el-input v-else v-model="items.content_y" type="textarea" :placeholder="$t('message.businessDecisions')"
                onfocus="this.select()" @input="allText('content_y', items.content_y, items.checked)"></el-input>
            </li>
            <li class="flex2">
              <el-select v-model="items.g_deal_type" placeholder="请选择" size="mini" clearable filterable
                @change="allText('g_deal_type', items.g_deal_type, items.checked)">
                <el-option v-for="item in g_deal_type" :key="item.key" :label="item.key" :value="item.key">
                </el-option>
              </el-select>
            </li>
            <!-- 采购处理备注  -->
            <li class="flex2">
              <el-input v-model="items.content_g" type="textarea" :placeholder="$t('message.procurementProcessRemark')"
                onfocus="this.select()" @input="allText('content_g', items.content_g, items.checked)"></el-input>
            </li>
            <!-- 修改后数量  -->
            <li>
              <el-input v-model="items.editNum" size="small" :placeholder="$t('message.editNumber')"
                onfocus="this.select()" @input="allText('editNum', items.editNum, items.checked)"></el-input>
            </li>
            <!-- 修改后单价  -->
            <li>
              <el-input v-model="items.editPrice" size="small" :placeholder="$t('message.editPrice')"
                onfocus="this.select()" @input="allText('editPrice', items.editPrice, items.checked)"></el-input>
            </li>
            <!-- 修改后运费.元  -->
            <li>
              <el-input v-model="items.editFreight" size="small" :placeholder="$t('message.editFreight')"
                onfocus="this.select()" @input="allText('editFreight', items.editFreight, items.checked)"></el-input>
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <p class="fl" style="color: #b4272d">
          注意：
          出入金调整是以采购处理完成为节点的，采购【确认处理完成】后，相应的出入金会自动调整，请谨慎确认后处理。
        </p>
        <!--修改后数据计算 -->
        <!-- <el-button type="primary" class="primary">{{
          $t("message.calculateTheDataAfterModification")
        }}</el-button> -->
        <!--数量价格运费修改 -->
        <!-- <el-button type="primary" class="primary">{{
          $t("message.quantityPriceFreightModification")
        }}</el-button> -->
        <!--确认处理完成 -->
        <el-button type="primary" @click="problemG_deal">
          {{ $t("message.confirmProcessingIsComplete") }}
        </el-button>
      </span>
    </el-dialog>
    <!-- 查看大图 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="picDialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
    <!-- 退换货 -->
    <productReturnAndExchange :list="productReturnAndExchangeList" ref="productReturnAndExchange" />
  </div>
</template>
<script>
import productReturnAndExchange from './productReturnAndExchange'
export default {
  components: {
    productReturnAndExchange
  },
  data() {
    return {
      dialogVisible: false,
      picDialogVisible: false,
      dialogImageUrl: "",
      checkedList: [],
      checked: false,
      g_deal_type: [
        { key: '退货退款' },
        { key: '换货' },
        { key: '丢货重拍' },
        { key: '少货补买' },
        { key: '其他' },
        { key: '仅退款' },
      ],
      productReturnAndExchangeDialogVisible: false,//退换货
      productReturnAndExchangeList: [],//退换货列表
    };
  },
  computed: {},
  methods: {
    handleClose() {
      this.$confirm(this.$t("message.confirmTheShutDown"))
        .then((_) => {
          this.dialogVisible = false;
          this.$store.commit("setProblemDialogVisible");
        })
        .catch((_) => { });
    },
    changeItem() {
      this.checkedList = [];
      this.$parent.disposeList.forEach((item) => {
        item.list.forEach((items) => {
          if (items.checked) {
            this.checkedList.push(items);
          }
        });
      });
    },
    //单选
    choice() {
      let list = []
      this.$parent.disposeList.forEach(item => {
        item.list.forEach(items => {
          if (items.checked) {
            list.push(item)
          }
        })
      })
      this.checked = list.every(item => item.checked)
      this.$forceUpdate()
    },
    //全选
    allChecked() {
      this.$parent.disposeList.forEach(item => {
        item.list.forEach(items => {
          items.checked = this.checked
        })
      })
      this.$forceUpdate()
    },
    //批量修改
    allText(tpye, text, checked) {
      if (checked) {
        this.$parent.disposeList.forEach(item => {
          item.list.forEach(items => {
            if (items.checked) {
              items[tpye] = text
            }
          })
        })
      }
      this.$forceUpdate()
    },
    //问题产品-采购处理
    problemG_deal() {

      let datas = {
        data: [],
      };
      let optionStr = ''
      this.productReturnAndExchangeList = []

      this.$parent.disposeList.forEach((item) => {
        item.list.forEach((items) => {
          datas.data.push({
            problem_goods_id: items.problem_goods_id,
            pre_num: items.editNum,
            pre_freight: items.editFreight,
            pre_price: items.editPrice,
            content: items.content_g,
            g_deal_type: items.g_deal_type
          });
          // 退换货
          if (items.g_deal_type == '退货退款' || items.g_deal_type == '换货') {
            // 判断 是否是替换链接
            let data = JSON.parse(JSON.stringify(items))
            if (items.replace_goods_info != '') {
              data.detail_y = items.replace_goods_info.new.detail_y
              data.pic = items.replace_goods_info.new.pic
              data.shop_name = items.replace_goods_info.new.shop_name
              data.from_platform = items.replace_goods_info.new.from_platform
              data.shop_id = items.replace_goods_info.new.shop_id
            }
            this.productReturnAndExchangeList.push(data)
          }
          // 详细检品(单价) 收费检查
          let option = items.option_new != null ? items.option_new : items.option
          if (option != undefined) {
            let optionData = option.find(opti => opti.name == '详细检品(单价)')
            let price = items.pre_price != items.offer_price_bak ? items.pre_price : items.offer_price_bak
            if (optionData != undefined) {
              if (price <= 30) {
                if ((price > 15 && optionData.price != 2) || (price <= 15 && optionData.price != 1.5)) {
                  optionStr += `<span  style="color:red;">${items.sorting}番</span>，详细检品收费与收费标准不一致，请确认后再处理。<br/>`
                }
              }
            }
          }
        });
      });
      // console.log(123);

      if (datas.data.some((item) => item.content_g))
        return this.$message.error("有订单数据未填写，请核对后提交");
      if (datas.data.some((item) => !item.g_deal_type))
        return this.$message.error("有商品采购处理未选择，请核对后提交");
      if (datas.data.some((item) => item.pre_num == 0)) {
        this.$alert("修改后数量为0,请确认运费是否需要修改！", "提示", {
          confirmButtonText: "确定",
          callback: (action) => {
            if (action == 'confirm') {
              this.g_deal(datas, optionStr)
            }
          },
        });
      } else {
        this.g_deal(datas, optionStr)
      }
    },
    // 采购处理
    g_deal(datas, optionStr) {
      if (optionStr) {
        this.$alert(`<div style="font-size:20;px;max-height: 500px;
  overflow-y: auto;">
       ${optionStr}
        </div>`, '提示', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定',
          callback: action => {
            if (action == 'confirm') {
              this.$api.problemApi.g_deal(datas).then((res) => {
                if (res.code != 0) return this.$message.error(res.msg);
                this.$message.success(res.msg);
                this.dialogVisible = false;
                this.$parent.problemList();
                this.setProductReturnAndExchange()
              });
            }
          }
        });
      } else {
        this.$api.problemApi.g_deal(datas).then((res) => {
          if (res.code != 0) return this.$message.error(res.msg);
          this.$message.success(res.msg);
          this.dialogVisible = false;
          this.$parent.problemList();
          this.setProductReturnAndExchange()
        });
      }
    },
    // 创建退换货
    setProductReturnAndExchange() {
      if (this.productReturnAndExchangeList != false) {
        this.$refs.productReturnAndExchange.dialogVisible = true
        let g_deal_type = this.productReturnAndExchangeList[0].g_deal_type
        this.$refs.productReturnAndExchange.val = g_deal_type == '退货退款' ? 1 : 2
        this.$forceUpdate()
      }
    },

    //手续费选择【已收不退】后，
    hintIrreversible() {
      this.$alert(
        "商品数量减少时：将不会自动退还客户由于商品数量减少导致的手续费差额！商品数量增加时：还是会自动和客户收取数量增加的手续费差额！",
        "已收不退",
        {
          confirmButtonText: "确定",

          callback: (action) => {
            // this.$message({
            //   type: "info",
            //   message: `action: ${action}`,
            // });
          },
        }
      );
    },
    //手续费选择【多退少补】后，
    hintFillLesse() {
      this.$alert(
        "手续费选择【多退少补】后,商品数量减少时：将自动退还客户由于商品数量减少导致的手续费差额！",
        "多退少补",
        {
          confirmButtonText: "确定",

          callback: (action) => { },
        }
      );
    },
    //按业务修改值计算
    hintOption(option) {
      let flag = option.some((item) => item.tag == "①" || item.tag == "③");
      if (flag) {
        this.$alert(
          "当前选中各番存在【1)摄影】【3)配套】请确认是否已经修改好相应的 附加服务 数量及价格！",
          "提示",
          {
            confirmButtonText: "确定",
            callback: (action) => { },
          }
        );
      }
    },
    //修改后的数量为0的时候
    no0(num) {
      if (num == 0) {
        this.$alert("修改后数量为0,请确认运费是否需要修改！", "提示", {
          confirmButtonText: "确定",
          callback: (action) => { },
        });
      }
    },
    // 查看大图
    handlePictureCardPreview(url) {
      this.dialogImageUrl = url;
      this.picDialogVisible = true;
    },
    //批量填充
    bulkFilling() {
      this.$parent.disposeList.forEach(item => {
        item.list.forEach(items => {
          items.editNum = items.possible_num - items.num
        })
      })
    },
  },
};
</script>
<style lang='scss' scoped>
@import "@/css/mixin.scss";

.table {
  padding: 0 10px;
  max-height: 600px;
  overflow-y: auto;
  position: relative;

  ol {
    display: flex;
    font-size: 14px;
    height: 40px;
    background-color: #edeff4;
    position: sticky;
    left: 0;
    top: 0;
    z-index: 999;
  }

  ul {
    display: flex;
    border-bottom: 1px solid #e8e8e8;
    padding: 10px 0;
    font-size: 12px;
    transition: 0.25s;

    &:hover {
      background-color: #eee;
      cursor: pointer;
    }

    li {
      width: 100%;
      overflow: hidden;

      //   max-height: 80px;
      label {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .template {
        text-align: left;
        width: 100%;
        max-height: 100px;

        p {
          line-height: 20px;
        }
      }

      .scope {
        max-height: 100px;

        p {
          line-height: 20px;
        }
      }

      .imgList {
        display: flex;
        flex-wrap: wrap;
        text-align: center;

        .imgs {
          margin: 0 20px 10px 0;

          &:nth-child(even) {
            margin-right: 0;
          }

          &:nth-child(n + 2) {
            margin-bottom: 0;
          }

          img {
            width: 50px;
            height: 50px;
          }
        }
      }
    }

    .img {
      img {
        width: 60px;
        height: 60px;
        border-radius: 4px;
      }
    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 0 3px;
  }

  .flex05 {
    flex: 0.5;
  }

  .flex15 {
    flex: 1.3;
  }

  .flex2 {
    flex: 1.7;
  }

  .flex25 {
    flex: 2.3;
  }

  .detail {
    .head {
      height: 50px;
      display: flex;
      background-color: #dedeef;
      font-size: 14px;
      line-height: 50px;
      padding: 0 20px;
      position: relative;

      .bulkFilling {
        position: absolute;
        right: 160px;
        top: 0;
      }

      a {
        color: #000;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

  .noData {
    padding: 20px 0;
    text-align: center;
  }
}

/deep/.el-textarea__inner {
  height: 80px;
  padding: 3px;
}

/deep/.el-input__inner {
  padding: 2px;
  text-align: center;
}
</style>